<template>
  <v-container
    v-if="authenticationMixin.checkedLogin"
    class="content content-with-nav pa-0"
    fluid
  >
    <!-- Hero section -->
    <page-hero
      title="Foto's"
      intro="Wat zijn uw wensen in verband met het gebruik van foto's tijdens de plechtigheid?"
    />

    <!-- Content -->
    <v-row justify="center">
      <v-col
        class="center"
        cols="12"
        md="10"
        lg="6"
      >
        <div class="fotos-card">
          <div class="fotos-card-header">
            <v-icon
              color="#907322"
              size="22"
            >
              mdi-camera-outline
            </v-icon>
            <h2 class="fotos-card-title">
              Voorkeuren
            </h2>
          </div>

          <v-select
            v-model="algemeneInfo.hoeFotosTonenValue"
            base-color="primary"
            bg-color="white"
            color="primary"
            density="compact"
            item-title="longDescription"
            item-value="value"
            :items="fotosOpties"
            label="Wat met foto's tijdens de plechtigheid?"
            variant="outlined"
          />

          <v-select
            v-model="algemeneInfo.aanleverenFotosValue"
            base-color="primary"
            bg-color="white"
            color="primary"
            density="compact"
            item-title="longDescription"
            item-value="value"
            :items="fotosTypeOpties"
            label="Hoe worden de foto's aangeleverd?"
            variant="outlined"
          />

          <div class="d-flex justify-end">
            <v-btn
              color="primary"
              rounded
              @click="SaveGeneralInfo"
            >
              <v-icon
                class="mr-1"
                size="18"
              >
                mdi-content-save-outline
              </v-icon>
              Opslaan
            </v-btn>
          </div>
        </div>

        <div class="fotos-card mt-4 mb-8">
          <div class="fotos-card-header">
            <v-icon
              color="#907322"
              size="22"
            >
              mdi-information-outline
            </v-icon>
            <h2 class="fotos-card-title">
              Richtlijnen bij het aanleveren van de foto's
            </h2>
          </div>

          <h3 class="fotos-section-title">
            Digitale foto's
          </h3>
          <ul class="fotos-list">
            <li>In Jpeg-formaat</li>
            <li>Via WeTransfer of op stick (niet in een gewone mail)</li>
            <li>Alle foto's in één keer (één keer doorgestuurd, kan er niet meer gewijzigd worden)</li>
            <li>Genummerd indien de volgorde belangrijk is</li>
            <li>In mapjes per lied indien dit belangrijk is</li>
            <li><u>Ten laatste 24 uur voor de aanvang van de plechtigheid (zaterdag, zondag en feestdagen niet meegerekend)</u></li>
          </ul>

          <h3 class="fotos-section-title mt-4">
            Foto's om te scannen
          </h3>
          <ul class="fotos-list">
            <li>Genummerd indien de volgorde belangrijk is</li>
            <li>In mapjes per lied indien dit belangrijk is</li>
            <li><u>Ten laatste 48 uur voor de aanvang van de plechtigheid (zaterdag, zondag en feestdagen niet meegerekend)</u></li>
          </ul>

          <p class="fotos-hint mt-4">
            <v-icon
              class="mr-1"
              color="#907322"
              size="18"
            >
              mdi-lightbulb-outline
            </v-icon>
            Indien u zelf foto's scant, zorg dan voor een goede kwaliteit. Wij gebruiken de foto's zoals ze worden aangeleverd. Foto's van foto's raden we af.
          </p>
        </div>
      </v-col>
    </v-row>

    <!-- Navigation -->
    <div class="samenstellen-nav">
      <div class="samenstellen-nav-inner">
        <v-btn
          v-if="samenstellenNavigation_PreviousItem"
          color="primary"
          :disabled="samenstellenNavigation_PreviousItem.disabled"
          rounded
          variant="text"
          @click="samenstellenNavigation_GoToPrevious"
        >
          <v-icon start>
            mdi-chevron-left
          </v-icon>
          {{ samenstellenNavigation_PreviousItem.title }}
        </v-btn>
        <span v-else />
        <v-btn
          v-if="samenstellenNavigation_NextItem"
          color="primary"
          :disabled="samenstellenNavigation_NextItem.disabled"
          rounded
          variant="text"
          @click="samenstellenNavigation_GoToNext"
        >
          {{ samenstellenNavigation_NextItem.title }}
          <v-icon end>
            mdi-chevron-right
          </v-icon>
        </v-btn>
        <span v-else />
      </div>
    </div>
  </v-container>
</template>

<script>
import PageHero from '@/components/PageHero.vue'
import authenticationMixin from '@/mixins/authenticationMixin'
import commonMixin from '@/mixins/commonMixin'
import constantMixin from '@/mixins/constantMixin'
import errorMixin from '@/mixins/errorMixin'
import samenstellenNavigationMixin from '@/mixins/samenstellenNavigationMixin'
import klantService from '@/services/klantService'

export default {
  name: 'FotosComponent',
  components: { PageHero },
  mixins: [
    authenticationMixin,
    commonMixin,
    constantMixin,
    errorMixin,
    samenstellenNavigationMixin
  ],
  data () {
    return {
      fotosOpties: [],
      fotosTypeOpties: [],
      algemeneInfo: {}
    }
  },
  mounted () {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    this.AuthenticationMixin_CheckIfLoggedIn()
    this.$store.state.headers.samenstellen = true
    klantService.Init(this)
    this.LoadData()
  },
  beforeUnmount () {
    this.$store.state.headers.samenstellen = false
  },
  methods: {
    async LoadData () {
      this.CommonMixin_Load(this.$options.name, true)
      await Promise.all([
        this.GetFotosOpties(),
        this.GetFotosTypeOpties(),
        this.GetUitvaartFotos()
      ])
      this.CommonMixin_Load(this.$options.name, false)
    },
    async GetFotosOpties () {
      const resp = await klantService.GetUitvaartDraaiboekListCode()

      if (resp?.data) {
        this.fotosOpties = resp.data.filter(o => o.type === this.constantMixin.codes.fotosTijdensPlechtigheid.name)
      }
    },
    async GetFotosTypeOpties () {
      const resp = await klantService.GetUitvaartDraaiboekListCode()

      if (resp?.data) {
        this.fotosTypeOpties = resp.data.filter(o => o.type === this.constantMixin.codes.fotosAanlevering.name)
      }
    },
    async GetUitvaartFotos () {
      const resp = await klantService.GetUitvaartFotos()

      if (resp && (resp.data || resp.data !== '')) {
        this.algemeneInfo = resp.data
      }
    },
    async SaveGeneralInfo () {
      this.CommonMixin_Load(this.$options.name, true)
      await klantService.SaveUitvaartFotos(this.algemeneInfo)
      this.CommonMixin_Load(this.$options.name, false)
    }
  }
}
</script>

<style scoped>
.fotos-card {
  border: 1px solid #e8e4dc;
  border-radius: 10px;
  padding: 24px;
  background-color: #fdfcfa;
}

.fotos-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 2px solid #DEC067;
}

.fotos-card-title {
  font-size: 20px;
  font-weight: 500;
  color: #424E58;
  padding: 0;
  margin: 0;
}

.fotos-section-title {
  font-size: 14px;
  font-weight: 600;
  color: #907322;
  margin: 0 0 8px 0;
  padding: 0;
}

.fotos-list {
  padding-left: 20px;
  margin: 0;
}

.fotos-list li {
  font-size: 14px;
  color: #424E58;
  margin-bottom: 4px;
}

.fotos-hint {
  font-size: 13px;
  color: #6b6b6b;
  font-style: italic;
  display: flex;
  align-items: flex-start;
}
</style>
